export const GOOGLE_KEY = "AIzaSyD8t2MB7eqGWo03nF7ilyRn_UDERWAQH58";

console.log('🔍 Checking VITE_MIXPANEL_TOKEN:', import.meta.env.VITE_MIXPANEL_TOKEN);

export const MIXPANEL_TOKEN = import.meta.env.VITE_MIXPANEL_TOKEN || '79cf8ef02f4524d8baabb2407907b90d';

console.log('📦 MIXPANEL_TOKEN exported:', MIXPANEL_TOKEN);
